import { Avatar, Card, Typography } from "antd";
import React from "react";
import colors from "../../../../constants/colors";

export type ChatStatus = "online" | "offline";

export interface ChatContactCardProps {
  user: {
    name: string;
    status: string;
    bio: string;
    avatar: string;
    id: number;
  };
  lastMessageTime: string;
  isActive?: boolean;
  onClick: (key: number) => void;
}

const { Text } = Typography;

export const ChatContactCard: React.FC<ChatContactCardProps> = ({
  user,
  lastMessageTime,
  isActive,
  onClick,
}) => {
  const { name, status, avatar, bio, id } = user || {};

  return (
    <Card
      className={`border-0 cursor-pointer group transition-all ${
        isActive ? "bg-primary" : ""
      }`}
      classNames={{ body: "!p-2.5" }}
      data-active={isActive}
      onClick={() => onClick(id)}
    >
      {/* layout wrapper */}
      <div className="flex items-start gap-3">
        <span className="relative inline-block shrink-0">
          <Avatar src={avatar} size={40} />
          <span
            className="absolute bottom-0 right-0 block w-3 h-3 rounded-full border-2 border-white"
            style={{
              background:
                status === "online" ? colors.success.color : "#AAB3C3",
            }}
          />
        </span>
        {/* main content */}
        <div className="flex-1 min-w-0">
          <div>
            <div className="flex items-start justify-between gap-2">
              <Text className="text-[#8897AE] text-xs group-data-[active=true]:text-white">
                {status === "online" ? "Online" : "Offline"}
              </Text>
              <Text className="text-[#8897AE] group-data-[active=true]:text-white text-xs">
                {lastMessageTime}
              </Text>
            </div>
            <Text
              className="text-header text-sm font-semibold group-data-[active=true]:text-white"
              ellipsis
            >
              {name}
            </Text>
          </div>
          <div>
            <Text
              className="text-[#8897AE] group-data-[active=true]:text-white text-xs"
              ellipsis
            >
              {bio}
            </Text>
          </div>
        </div>
        {/* {prefix ? <div className="ml-2 shrink-0">{prefix}</div> : null} */}
      </div>
    </Card>
  );
};
